import { useEffect } from "react";
import LayoutDashboard from "../components/layout/LayoutDashboard.component";
import { TableSonho } from "../components/sonhos";
import { useSonho } from "../services/sonhos";
import { useStores } from "../components/contexts/store-provider.context";
import { toJS } from "mobx";
import { memoObserver } from "../utils/memoObserver.utils";

export const DashboardSonhos = memoObserver(() => {
  const { getSonhos } = useSonho();
  const { sonhoStore } = useStores();

  useEffect(() => {
    getSonhos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LayoutDashboard>
      <TableSonho
        loading={sonhoStore.loading}
        data={toJS(sonhoStore.data) || []}
      />
    </LayoutDashboard>
  );
});
